module.exports = __webpack_public_path__ + "static/media/有無準備防災包.3f5d5b31.png";